(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bought-with"] && !Shopify.designMode) return;
  try {
    
  class BoughtWith extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-bw-rail]');
      const prev = document.querySelector('[data-bw-prev]');
      const next = document.querySelector('[data-bw-next]');
      if (!this.rail) return;
      const step = () => this.rail.clientWidth * 0.5;
      if (prev) prev.addEventListener('click', () => this.rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.rail.scrollBy({ left: step(), behavior: 'smooth' }));
      const sync = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth - 2;
        if (prev) prev.disabled = this.rail.scrollLeft <= 2;
        if (next) next.disabled = this.rail.scrollLeft >= max;
      };
      this.rail.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }
  customElements.define('bought-with', BoughtWith);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  class ComparisonTable extends HTMLElement {
    connectedCallback() {
      const table = this.querySelector('.cmp__table');
      const tabs = Array.from(this.querySelectorAll('[data-cmp-tab]'));
      if (!table || !tabs.length) return;
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          table.dataset.rival = tab.dataset.cmpTab;
          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      });
    }
  }
  customElements.define('comparison-table', ComparisonTable);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diagnostic"] && !Shopify.designMode) return;
  try {
    
  class DiagQuiz extends HTMLElement {
    connectedCallback() {
      this.total = Number(this.dataset.total) || 1;
      this.steps = Array.from(this.querySelectorAll('[data-diag-step-panel]'));
      this.results = Array.from(this.querySelectorAll('[data-diag-result]'));
      this.fill = this.querySelector('[data-diag-fill]');
      this.counter = this.querySelector('[data-diag-step]');
      this.back = this.querySelector('[data-diag-back]');
      this.exit = this.querySelector('[data-diag-exit]');
      this.restart = this.querySelector('[data-diag-restart]');
      this.picked = [];

      this.querySelectorAll('[data-diag-pick]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.picked[this.index] = btn.dataset.tag || '';
          this.index + 1 < this.steps.length ? this.go(this.index + 1) : this.finish();
        });
      });
      if (this.back) this.back.addEventListener('click', () => this.go(this.index - 1));
      if (this.restart) this.restart.addEventListener('click', () => { this.picked = []; this.go(0); });

      /* Skip the announcement on first paint: nothing has moved yet. */
      this.go(0, false);
    }

    go(i, announce = true) {
      this.index = Math.max(0, Math.min(i, this.steps.length - 1));
      this.steps.forEach((s, n) => { s.hidden = n !== this.index; });
      this.results.forEach((r) => { r.hidden = true; });
      this.setBar(this.index + 1);
      /* Step one has nothing to go back to, so the link leaves the quiz. */
      if (this.back) this.back.hidden = this.index === 0;
      if (this.exit) this.exit.hidden = this.index !== 0;
      if (this.restart) this.restart.hidden = true;
      if (announce) this.focusStep();
    }

    finish() {
      const counts = {};
      this.picked.forEach((t) => { if (t) counts[t] = (counts[t] || 0) + 1; });
      const winner = Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];
      const match = this.results.find((r) => r.dataset.diagResult === winner) || this.results[0];

      this.steps.forEach((s) => { s.hidden = true; });
      this.results.forEach((r) => { r.hidden = r !== match; });
      this.setBar(this.total);
      if (this.back) this.back.hidden = true;
      if (this.exit) this.exit.hidden = true;
      if (this.restart) this.restart.hidden = false;
      this.focusStep();
    }

    setBar(n) {
      if (this.fill) this.fill.style.setProperty('--pct', `${(n / this.total) * 100}%`);
      if (this.counter) this.counter.textContent = n;
    }

    focusStep() {
      const shown = this.querySelector('[data-diag-step-panel]:not([hidden]), [data-diag-result]:not([hidden])');
      const heading = shown && shown.querySelector('.diag__q');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
  }
  customElements.define('diag-quiz', DiagQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-final-cta"] && !Shopify.designMode) return;
  try {
    
  /* Reuse the page's own picker and add button, so pricing, availability and
     line item properties stay in one place. */
  document.addEventListener('DOMContentLoaded', () => {
    const box = document.querySelector('[data-final-cta]');
    if (!box) return;

    box.querySelectorAll('[data-fcta-pick]').forEach((chip) => {
      chip.addEventListener('click', () => {
        const value = chip.dataset.fctaPick;
        const pos = chip.dataset.fctaPos;
        const input = Array.from(document.querySelectorAll(`variant-picker input[name="option${pos}"]`))
          .find((i) => i.value === value);
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        box.querySelectorAll('[data-fcta-pick]').forEach((c) => c.classList.toggle('is-on', c === chip));
        const out = box.querySelector('[data-fcta-value]');
        if (out) out.textContent = value;
      });
    });

    const add = box.querySelector('[data-fcta-add]');
    if (add) {
      add.addEventListener('click', () => {
        const main = document.querySelector('[data-add-button]');
        if (main) main.click();
      });
    }

    document.addEventListener('variant:change', () => {
      const fresh = document.querySelector('[data-price] .price');
      const target = box.querySelector('[data-fcta-price]');
      if (fresh && target) target.innerHTML = fresh.outerHTML;
    });

    /* Picking a pack settles the price straight away; waiting for the variant
       fetch left this block quoting the previous pack for the length of the
       round trip, and for good when it failed. */
    document.addEventListener('lot:change', (e) => {
      const target = box.querySelector('[data-fcta-price]');
      const money = window.theme && window.theme.formatMoney;
      if (!target || !money || !Number.isFinite(e.detail.total)) return;
      target.textContent = money(e.detail.total);
    });

    /* The sticky bar is redundant once this block is on screen. */
    const sticky = document.querySelector('sticky-atc');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.dataset.suppressed = entry.isIntersecting ? 'true' : 'false';
      }, { rootMargin: '0px 0px -10% 0px' }).observe(box);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-page"] && !Shopify.designMode) return;
  try {
    
  /* Filtering is client-side: these are curated quotes, not a paginated feed.
     The first button is the "everything" one. */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rfilter]');
    if (!btn) return;
    const scope = btn.closest('.rpage');
    if (!scope) return;

    const buttons = Array.from(scope.querySelectorAll('[data-rfilter]'));
    buttons.forEach((b) => {
      const on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const want = btn.dataset.rfilter;
    const showAll = btn === buttons[0];
    let shown = 0;

    scope.querySelectorAll('.rev').forEach((card) => {
      const tags = (card.dataset.tags || '').split(',').map((t) => t.trim());
      const show = showAll || tags.includes(want);
      card.hidden = !show;
      if (show) shown += 1;
    });

    const empty = scope.querySelector('[data-rempty]');
    if (empty) empty.hidden = shown > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-summary"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-review-more]');
    if (!btn) return;
    const scope = btn.closest('.rsum__wrap');
    const extra = scope ? scope.querySelectorAll('[data-extra]') : [];
    if (!extra.length) return;
    const opening = extra[0].hidden;
    extra.forEach((el) => { el.hidden = !opening; });
    btn.textContent = opening ? btn.dataset.less : btn.dataset.more;
    /* Collapsing from the bottom of a long list leaves the viewport in
       nowhere; bring the button back into view. */
    if (!opening) btn.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-plans"] && !Shopify.designMode) return;
  try {
    
  class SubsPicker extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.spick__panel');
      document.querySelectorAll('[data-subs-pick]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(btn.dataset.plan || ''));
      });
      this.querySelectorAll('[data-spick-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    open(plan) {
      /* The chosen rhythm rides along so the product page can preselect it. */
      if (plan) {
        try { sessionStorage.setItem('subsPlan', plan); } catch (e) { /* private mode */ }
        this.querySelectorAll('.scol').forEach((a) => {
          const url = new URL(a.href, window.location.origin);
          url.searchParams.set('plan', plan);
          a.href = url.toString();
        });
      }
      this.hidden = false;
      this.opener = document.activeElement;
      requestAnimationFrame(() => { this.dataset.open = 'true'; });
      document.documentElement.style.overflow = 'hidden';
      const first = this.querySelector('.scol, .spick__close');
      if (first) first.focus();
    }

    close() {
      if (this.hidden) return;
      this.dataset.open = 'false';
      document.documentElement.style.overflow = '';
      const done = () => { this.hidden = true; };
      if (this.panel) {
        this.panel.addEventListener('transitionend', done, { once: true });
        setTimeout(done, 400);
      } else {
        done();
      }
      if (this.opener && this.opener.focus) this.opener.focus();
    }
  }
  customElements.define('subs-picker', SubsPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-grid"] && !Shopify.designMode) return;
  try {
    
  /* Autoplay only while the tile is on screen. Four clips looping out of
     view wastes bandwidth, and iOS refuses to start several at once. */
  (() => {
    const autos = document.querySelectorAll('[data-ugc-auto]');
    if (!autos.length) return;
    if (!('IntersectionObserver' in window)) { autos.forEach((v) => v.play().catch(() => {})); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) target.play().catch(() => {});
        else target.pause();
      });
    }, { threshold: 0.35 });
    autos.forEach((v) => io.observe(v));
  })();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ugc-play]');
    if (!btn) return;
    const card = btn.closest('.ugc__card');
    const video = card && card.querySelector('[data-ugc-video]');
    if (!video) return;
    document.querySelectorAll('[data-ugc-video]').forEach((v) => {
      if (v !== video) { v.pause(); v.closest('.ugc__card').classList.remove('is-playing'); }
    });
    card.classList.add('is-playing');
    video.play();
  });

  } catch(e) { console.error(e); }
})();
})();
